import { render, staticRenderFns } from "./FormaToggle.vue?vue&type=template&id=0ca6c5bd&scoped=true&"
import script from "./FormaToggle.vue?vue&type=script&lang=js&"
export * from "./FormaToggle.vue?vue&type=script&lang=js&"
import style0 from "./FormaToggle.vue?vue&type=style&index=0&id=0ca6c5bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6c5bd",
  null
  
)

export default component.exports